import { Tag } from "antd"
import { useTranslation } from "react-i18next"

import { type MilestoneScheduleRisk } from "../../../../../redux/project-milestones/project-milestones.types.ts"

const RISK_TAGS: Record<
  MilestoneScheduleRisk,
  { label: string; color: string }
> = {
  on_track: { label: "On Track", color: "success" },
  at_risk: { label: "At Risk", color: "warning" },
  high_risk: { label: "High Risk", color: "error" }
}

export function MilestoneRiskTag({
  risk
}: {
  risk?: MilestoneScheduleRisk | null
}) {
  const { t } = useTranslation()
  const tag = risk ? RISK_TAGS[risk] : undefined

  if (!tag || !risk) return null

  return <Tag color={tag.color}>{t(`milestone.risk.${risk}`, tag.label)}</Tag>
}
